// @ts-nocheck
import { CELL, CHUNK } from "./constants";
import { mapState, mapRefs } from "./state";

export type WorldBounds = {
  wx1: number;
  wy1: number;
  wx2: number;
  wy2: number;
};

const BBOX_MARGIN = CHUNK * CELL;

export function getVisibleWorldBounds(
  camX?: number,
  camY?: number,
): WorldBounds {
  const viewport = mapRefs.viewport;
  const cx = camX ?? mapState.camX;
  const cy = camY ?? mapState.camY;
  let vis = 800;
  if (viewport) {
    const vw = viewport.offsetWidth;
    const vh = viewport.offsetHeight;
    vis = (Math.max(vw, vh) * 0.8) / mapState.zoomLevel;
  }
  vis += BBOX_MARGIN;
  return {
    wx1: cx - vis,
    wy1: cy - vis,
    wx2: cx + vis,
    wy2: cy + vis,
  };
}

export function boundsAroundPoint(
  wx: number,
  wy: number,
  radius = 800,
): WorldBounds {
  return {
    wx1: wx - radius,
    wy1: wy - radius,
    wx2: wx + radius,
    wy2: wy + radius,
  };
}

export function isWorldPointInBounds(
  wx: number,
  wy: number,
  bounds: WorldBounds,
): boolean {
  const minWx = Math.min(bounds.wx1, bounds.wx2);
  const maxWx = Math.max(bounds.wx1, bounds.wx2);
  const minWy = Math.min(bounds.wy1, bounds.wy2);
  const maxWy = Math.max(bounds.wy1, bounds.wy2);
  return wx >= minWx && wx <= maxWx && wy >= minWy && wy <= maxWy;
}

function boundsContains(outer: WorldBounds, inner: WorldBounds): boolean {
  const oMinWx = Math.min(outer.wx1, outer.wx2);
  const oMaxWx = Math.max(outer.wx1, outer.wx2);
  const oMinWy = Math.min(outer.wy1, outer.wy2);
  const oMaxWy = Math.max(outer.wy1, outer.wy2);
  const iMinWx = Math.min(inner.wx1, inner.wx2);
  const iMaxWx = Math.max(inner.wx1, inner.wx2);
  const iMinWy = Math.min(inner.wy1, inner.wy2);
  const iMaxWy = Math.max(inner.wy1, inner.wy2);
  return (
    oMinWx <= iMinWx &&
    oMaxWx >= iMaxWx &&
    oMinWy <= iMinWy &&
    oMaxWy >= iMaxWy
  );
}

export function boundsNeedFetch(
  visible: WorldBounds,
  loaded: WorldBounds[],
): boolean {
  if (loaded.length === 0) return true;
  return !loaded.some((bbox) => boundsContains(bbox, visible));
}
